import I18n from '@utils/i18n';

// 编辑行互斥，只能编辑其中一行 'nickName' | 'intro' | 'avatar' | 'locale' | 'rate'| 'zone'

export const EDIT_ROW = {
  /** 昵称 */
  NICK_NAME: 'nickName',
  /** 简介 */
  INTRO: 'intro',
  /** 头像 */
  AVATAR: 'avatar',
  /** 语言 */
  LOCALE: 'locale',
  /** 汇率 */
  RATE: 'rate',
  /** 地区 */
  ZONE: 'zone'
}

/** 中英文社区切换 */
export const zoneOptions = () => [
  { label: I18n.t('WLz42cIZ'), value: 'HK' },
  { label: I18n.t('vSpcNSu5'), value: 'EN' }
]
